import * as React from 'react'

import { F0DatePicker } from '@factorialco/f0-react'
import type { DatePickerValue } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
}

const ExportMonthSelector = ({ form }: Props) => {
  const startDate = form.get('from')
  const endDate = form.get('to')

  const dateValue = React.useMemo(() => {
    const from = startDate.value ? stringToDate(startDate.value, 'ui').toDate() : undefined
    const to = endDate.value ? stringToDate(endDate.value, 'ui').toDate() : undefined

    if (!from || !to) return undefined

    return {
      granularity: 'range' as const,
      value: {
        from,
        to,
      },
    }
  }, [startDate.value, endDate.value])

  const handleDateChange = (
    date: DatePickerValue | undefined,
    _stringValue?: string | undefined
  ) => {
    if (date?.value) {
      const fromFormatted = date.value.from ? i18nDateToString(date.value.from, 'ui') : undefined
      const toFormatted = date.value.to ? i18nDateToString(date.value.to, 'ui') : undefined

      startDate.set(fromFormatted)
      endDate.set(toFormatted)
    }
  }

  return (
    <FormRow>
      <F0DatePicker
        label={i18n.t('time_off.date_range.label')}
        onChange={handleDateChange}
        size="sm"
        value={dateValue}
      />
    </FormRow>
  )
}

export default observer(ExportMonthSelector)
